import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {FeatureEventData, slotStore} from '@gongxigames/framework/slotV2/globals';
import {listenUIDisabled} from '@gongxigames/framework/slotV2/ui/acts/utils';

export class RespinSpinUIAct extends SyncUIActDecorator {
    public execute(): void {
        listenUIDisabled(this);

        this.emitter.on('Game.command.round.featureAccepted', () => {
            this.emitter.emit('Game.command.buyFeature.hide');
        });
        this.emitter.on('UI.quickStopButton.pressed', this.onSkipStartedByButton.bind(this));

        this.emitter.emit('General.disableSpinButton');
        this.emitter.emit('UI.updateUIElementsState', 'RespinUIState');
        this.emitter.on('Game.command.round.featureStopped', (data: FeatureEventData) => {
            if (data.type === 'respins') {
                slotStore.batchUpdate({
                    feature_type: null
                });
                this.onExecuted?.();
            }
        });

        this.emitter.on('Game.command.round.featureStarted', (data: FeatureEventData) => {
            slotStore.batchUpdate({
                feature_type: data
            });
            this.onExecuted?.();
        });
    }

    protected onSkipStartedByButton(): void {
        this.emitter.emit('UI.command.spin');
    }

    getName(): string {
        return 'RespinSpinUIAct';
    }
}